import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Divider,
} from "@material-ui/core";
import Page from "src/components/Page";
import LoginForm from "./LoginForm";
import { useStyles } from "./LoginStyles";
import { useTranslation } from "react-i18next";

function Login() {
  const classes = useStyles();
  const { t } = useTranslation(["common"]);

  return (
    <Page className={classes.root} title={t("auth.login")}>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography gutterBottom variant="h3">
            {t("auth.sign_in")}
          </Typography>
          <Typography variant="subtitle1">{t("welcome_to")}</Typography>
          <LoginForm className={classes.loginForm} />
          <Divider className={classes.divider} />
        </CardContent>
        <CardMedia
          className={classes.media}
          image="/images/auth.png"
          title="Cover"
        ></CardMedia>
      </Card>
    </Page>
  );
}

export default Login;
